// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"PageHeading_pageHeading__4FWzp","ingress":"PageHeading_ingress__qCs_O"};